export default {
  title: {
    en: 'SUCCESSFULLY RESUBSCRIBED!',
  },
  text: {
    en: `
      Great to have you back. If you're ready for a refresh, <br>
      our scent quiz is a great place to start again.
    `,
  },
  btnTakeScentQuiz: {
    en: 'Take scent quiz',
  },
  btnExploreOnMyOwn: {
    en: 'I\'ll just explore on my own',
  },
}
